import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
};
